import React from 'react'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'
import type { EventKey } from '@classic/Foundation/Analytics/GoogleTagManagerService'

type TrackEventOnMountPayload = {
  eventName: EventKey
  data?: Record<string, unknown>
}

export function useTrackEventOnMount(event: TrackEventOnMountPayload) {
  const capturedEventRef = React.useRef<TrackEventOnMountPayload>(event)
  React.useEffect(() => {
    trackEvent(capturedEventRef.current.eventName, capturedEventRef.current.data ?? {})
  }, [])
}
